module.exports = __webpack_public_path__ + "img/publisher.9f23b888.png";